<template>
  <div>
    <!-- <Head :Index="isIndex"/>
    <Banner :banner1="bannerObj1"/> -->
    <div class="vlovemother">
      <div class="auto_1280">
        <div class="intro clearfix">
          <div class="content">
            <div class="title">{{intro.title}}</div>
            <div class="txt">{{intro.content}}</div>
            <div class="qrcode">
              <img :src="intro.intro" alt="">
              <pre v-if="lan === 0">{{text}}</pre>
              <pre v-else-if="lan === 1">{{enText}}</pre>
            </div>
          </div>
          <div class="pic">
            <img :src="intro.coverImg" alt="">
            <svg width:="0" height="0">
              <defs>
                <clipPath id="svgPath" clipPathUnits="objectBoundingBox" transform="scale(0.0017452006980803, 0.0018315018315018)">
                  <path fill="rgb(228, 0, 127)" opacity="0.149" fill-rule="evenodd" stroke="#000000" stroke-width="1.5794" stroke-miterlimit="10" d="M27.967,327.074 C27.967,327.074 53.947,379.133 108.689,412.472 C163.431,445.810 195.256,453.602 267.059,465.557 C338.862,477.512 415.280,488.077 464.637,461.710 C513.994,435.343 538.848,388.836 536.134,313.996 C533.420,239.155 527.082,188.996 502.307,132.430 C477.533,75.864 439.451,37.275 416.203,19.336 C392.956,1.396 353.825,-9.297 270.134,15.489 C186.444,40.275 139.582,55.866 95.620,78.576 C51.658,101.285 10.960,118.412 3.366,180.129 C-4.229,241.847 2.862,280.121 27.967,327.074 Z" />
                </clipPath>
              </defs>
            </svg>
          </div>
        </div>
      </div>
      <div class="welfare-video">
        <div class="auto_1280">
          <div class="tit">{{intro.tag}}</div>
          <ul class="ul clearfix">
            <li v-for="item in welfareVideoList" :key="item.id">
              <div class="item" @click="videoDetail(item)">
                <div class="poster">
                  <div class="item-pic bg_cover" :style="'background-image: url(' +  item.coverImg + ')'"></div>
                  <div class="cover"><span class="icon" v-if="item.isUpload === 1"></span></div>
                </div>
                <div class="item-title dot">{{item.title}}</div>
              </div>
            </li>
          </ul>
          <div class="pager" v-if="welfareVideoList.length > 0">
            <span class="p_page">
              <a @click="pageIndex = ( pageIndex == 1 ? 1 : pageIndex - 1 );" class="a_prev" :class="{disable_prev: pageIndex == 1}"></a>
              <em class="num">
                <template v-for="( num, index ) in pageList">
                  <a @click="pageIndex = num;" :key="index" :class="[ num == pageIndex ? 'a_cur' : '' ]">{{num}}</a>
                </template>
              </em>
              <a @click="pageIndex = ( pageIndex == maxPageIndex ? maxPageIndex : pageIndex + 1 );" class="a_next" :class="{disable_next: pageIndex == maxPageIndex}"></a>
            </span>
          </div>
        </div>
      </div>
      <div class="video-box" v-if="showVideo">
        <video controls autoplay>
          <source :src="videoSrc" type="video/mp4" />
          <source :src="videoSrc" type="video/ogg" />
        </video>
        <div class="close" @click="close" v-if="lan === 0">关闭</div>
        <div class="close" @click="close" v-else-if="lan === 1">Close</div>
      </div>
    </div>
    <!-- <Bottom :Index="isIndex"/> -->
  </div>
</template>
<script>
// import Head from '@/components/header'
// import Banner from '@/components/banner'
// import Bottom from '@/components/bottom'
export default {
  // components: {
  //   Head,
  //   Banner,
  //   Bottom
  // },
  data () {
    return {
      isIndex: false,
      showVideo: false,
      intro: {},
      text: '关注唯爱妈妈\n官方微信公众号',
      enText: 'Follow VloveMother\nOfficial wechat account',
      bannerObj1: [],
      welfareVideoList: [],
      videoSrc: '',

      pageList: [],
      pageIndex: 1,
      pageSize: 6,
      total: 0,
      maxPageIndex: 1,
      lan: this.$store.state.isEn
    }
  },
  watch: {
    pageIndex (val, oldval) {
      if (val !== oldval) {
        this.init()
      }
    },
    '$store.state.isEn' () {
      this.lan = this.$store.state.isEn
      if (this.pageIndex !== 1) {
        this.pageIndex = 1
      } else {
        this.init()
      }
    }
  },
  mounted () {
    const self = this
    self.init()
  },
  methods: {
    init () {
      const self = this
      const id = parseInt(self.$route.query.columnId)
      self.$api.post('api/benefitArticle/queryByParam', { articleTypeId: id, current: self.pageIndex, pageSize: self.pageSize, state: 1, isDelete: 0, bLanguage: this.lan, tag: 'true' }, r => {
        if (r.data) {
          self.intro = r.data[0]
        }
      })
      self.welfareVideoList = []
      self.$api.post('api/benefitArticle/queryByParam', { articleTypeId: id, current: self.pageIndex, pageSize: self.pageSize, video: 'true', state: 1, isDelete: 0, bLanguage: this.lan }, r => {
        self.total = r.total
        self.welfareVideoList = r.data
        self.initPager()
      })
      self.$nextTick(function () {
        self.initEL()
      })
    },
    initPager () {
      const self = this
      const footerCount = 5
      self.pageList = []
      self.maxPageIndex = parseInt(self.total / self.pageSize) + (self.total % self.pageSize === 0 ? 0 : 1)
      let startPageIndex = self.pageIndex - parseInt(footerCount / 2)
      startPageIndex = startPageIndex < 1 ? 1 : startPageIndex
      for (let i = startPageIndex; i <= self.maxPageIndex; i++) {
        self.pageList.push(i)
        if (self.pageList.length >= footerCount) break
      }
    },
    initEL () {},
    videoDetail (item) {
      const index = this.$route.path.lastIndexOf('/')
      localStorage.setItem('path', this.$route.path.substring(index + 1, this.$route.path.length))
      localStorage.setItem('columnId', this.$route.query.columnId)
      this.$router.push({
        path: '/vlovemother/detail',
        query: {
          columnId: this.$route.query.columnId,
          articleTypeId: item.articleTypeId,
          id: item.id
        }
      })
    },
    close () {
      this.showVideo = false
    }
  }
}
</script>
<style scoped>
.vlovemother .intro{padding: 10% 0 6%;}
.vlovemother .content,
.vlovemother .pic{width: 50%; float: left;}
.vlovemother .content{padding-right: 15%; box-sizing: border-box;}
.vlovemother .title{font-size: 40px; color: #e4007f;}
.vlovemother .txt{font-size: 16px; line-height: 2; padding: 12% 0 15%;}
.vlovemother .pic{background: url(../../assets/vlovebg.png)no-repeat center; text-align: center; background-size: contain; position: relative;}
.vlovemother .pic img{width: 80%; clip-path: url(#svgPath); -webkit-clip-path: url(#svgPath);}
.vlovemother .qrcode pre{display: inline-block; vertical-align: middle; padding-left: 5%; line-height: 1.8; font-size: 14px; color: #666; font-weight: lighter;}

.vlovemother .welfare-video{background-color: #f8f8f8; padding: 5% 0 6% 0;}
.vlovemother .tit{font-size: 30px; padding-bottom: 1%;}
.vlovemother ul{margin: 0 -1.5625%;}
.vlovemother li{float: left; width: 33.3333%; padding: 0 1.5625%; margin: 2% 0; box-sizing: border-box; overflow: hidden; cursor: pointer;}
.vlovemother .poster{position: relative;}
.vlovemother .item-pic{width: 100%; padding-top: 56.25%;}
.vlovemother .cover{position: absolute; left: 0; top: 0; width: 0; width: 100%; height: 100%; background-color: rgba(0,0,0,.4); display: flex; justify-content: center; align-items: center;}
.vlovemother .icon{background: url(../../assets/play-icon.png)no-repeat center; width: 56px; height: 36px; display: inline-block; opacity: 0; transition: all .3s;}
.vlovemother .item-title{padding-top: 3%; font-size: 18px;}
.vlovemother li:hover .icon{opacity: 1;}

.vlovemother .video-box{position: fixed; left: 0; top: 0; background-color: rgba(0,0,0,.6); width: 100vw; height: 100vh; z-index: 200;}
.vlovemother video{width: 80%; max-width: 800px; position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); max-height: 80%;}
.vlovemother .close{position: fixed; top: 30px; right: 40px; color: #fff; cursor: pointer; width: 60px; line-height: 25px; text-align: center; border-radius: 5px 0;}
.vlovemother .close:hover{background-color: #fff; color: #000; transition: all .3s;}
@media(max-width: 960px){
  .vlovemother .content{padding-right: 5%;}
  .vlovemother .item-title{font-size: 16px;}
}
@media(max-width: 640px){
  .vlovemother .content,
  .vlovemother .pic{width: 100%; float: left;}
  .vlovemother .content{padding-right: 0;}
  .vlovemother .txt{padding: 4% 0;}
  .vlovemother li{width: 50%;}
  .vlovemother .title{font-size: 30px;}
  .vlovemother .qrcode img{max-width: 110px;}
  .vlovemother .icon{opacity: 1;}
}
@media(max-width: 480px){
  .vlovemother li{width: 100%; margin-bottom: 5%;}
  .vlovemother .item-title{padding-top: 2%;}
}
</style>
